import React from 'react';

import { GiftsAtDeviceIcon } from '@assets/icon';
import { PermissionEnum } from '@modules/permissions/entity';
import { IRouter } from '@routers/interface';

const routerGiftByDevice: IRouter = {
  path: '/gifts/gift-by-device',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'giftByDevice.router.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  icon: <GiftsAtDeviceIcon />,
  permissionCode: PermissionEnum.DeviceRewardItemsView,
};

export default routerGiftByDevice;
